module.exports = __webpack_public_path__ + "img/icone-desconto-ingresso.9cccf2f1.svg";